import type { DeliverySettingsAPIDeliveryOptionCode } from 'src/services/delivery-settings/types/DeliverySettingsAPIDeliveryOptionCode';

export const getDeliveryOptionHeading = (
  optionCode: DeliverySettingsAPIDeliveryOptionCode,
): string => {
  switch (optionCode) {
    case 'EXPRESS_24':
      return 'Express';
    case 'SATURDAY':
      return 'Saturday guaranteed';
    case 'FREE':
    case 'STANDARD':
    default:
      return 'Standard';
  }
};
